import { ReactNode } from 'react'

import svgPlusSrc from '@cowprotocol/assets/cow-swap/plus.svg'
import type { Currency, CurrencyAmount, Token } from '@cowprotocol/currency'

import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import styled from 'styled-components/macro'

import { ConfirmDetailsItem, ReceiveAmountTitle } from 'modules/trade'

import { RateInfo, RateInfoParams } from 'common/pure/RateInfo'
import { SolverLogo } from 'common/pure/SolverLogo/SolverLogo.pure'
import type { SolverCompetition } from 'common/types/soverCompetition'

import { StyledTimelinePlusIcon, SuccessTextBold, TimelineIconCircleWrapper } from '../../../styles'
import { TokenAmountDisplay } from '../../TokenAmountDisplay'

const WinningSolverContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export function ExecPriceContent({ rateInfoParams }: { rateInfoParams: RateInfoParams }): ReactNode {
  return (
    <ConfirmDetailsItem
      withTimelineDot
      label={
        <span>
          <Trans>Exec. price</Trans>
        </span>
      }
    >
      <span>
        <RateInfo noLabel rateInfoParams={rateInfoParams} />
      </span>
    </ConfirmDetailsItem>
  )
}

export function ReceivedContent({
  receivedAmount,
  receivedAmountUsd,
}: {
  receivedAmount: CurrencyAmount<Currency>
  receivedAmountUsd: CurrencyAmount<Token> | null
}): ReactNode {
  return (
    <ConfirmDetailsItem
      label={
        <ReceiveAmountTitle>
          <b>
            <Trans>Received</Trans>
          </b>
        </ReceiveAmountTitle>
      }
    >
      <b>
        <TokenAmountDisplay currencyAmount={receivedAmount} displaySymbol usdValue={receivedAmountUsd} />
      </b>
    </ConfirmDetailsItem>
  )
}

export function SolverContent({ winningSolver }: { winningSolver: SolverCompetition }): ReactNode {
  return (
    <ConfirmDetailsItem withTimelineDot label={t`Winning solver`}>
      <WinningSolverContainer>
        <b>{winningSolver.displayName || winningSolver.solver}</b>
        <SolverLogo solver={winningSolver} size={16} />
      </WinningSolverContainer>
    </ConfirmDetailsItem>
  )
}

export function SurplusConfig({
  surplusAmount,
  surplusAmountUsd,
}: {
  surplusAmount: CurrencyAmount<Currency>
  surplusAmountUsd: CurrencyAmount<Token> | null
}): ReactNode {
  return (
    <ConfirmDetailsItem
      label={
        <ReceiveAmountTitle
          icon={
            <TimelineIconCircleWrapper>
              <StyledTimelinePlusIcon src={svgPlusSrc} />
            </TimelineIconCircleWrapper>
          }
        >
          <SuccessTextBold>
            <Trans>Surplus received</Trans>
          </SuccessTextBold>
        </ReceiveAmountTitle>
      }
    >
      <SuccessTextBold>
        <TokenAmountDisplay currencyAmount={surplusAmount} displaySymbol usdValue={surplusAmountUsd} hideTokenIcon>
          +
        </TokenAmountDisplay>
      </SuccessTextBold>
    </ConfirmDetailsItem>
  )
}
